import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArchive(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M11.293 11.707a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 8.586V3a1 1 0 1 0-2 0v5.586L9.707 7.293a1 1 0 0 0-1.414 1.414l3 3ZM2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2a1 1 0 1 0 0 2h2v5h-1.793a1.5 1.5 0 0 0-1.06.44L13.585 15h-3.172l-3.56-3.56A1.5 1.5 0 0 0 5.793 11H4V6h2a1 1 0 0 0 0-2H4a2 2 0 0 0-2 2v14Zm16.414-7H20v7H4v-7h1.586l3.56 3.56a1.5 1.5 0 0 0 1.061.44h3.586a1.5 1.5 0 0 0 1.06-.44L18.415 13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
